// frontend/src/utils/moneda.js
// Totalización de importes en órdenes de trabajo (OTC y OTP).
//
// Un renglón puede estar en pesos y otro en dólares dentro de la misma orden.
// Sumar los importes crudos daría un número sin sentido, así que se usa el
// equivalente que el backend ya dejó calculado en cada ítem (importe_ars /
// importe_usd) con la cotización de la fecha que le corresponde.

export const MONEDAS_OT = [
  { valor: 'ARS', label: '$ (Pesos)' },
  { valor: 'USD', label: 'USD (Dólares)' },
];

/** Símbolo a anteponer a los importes. */
export const simboloMoneda = (moneda) => (moneda === 'USD' ? 'USD' : '$');

/**
 * Importe de un ítem expresado en la moneda pedida.
 *
 * Usa la columna bimoneda del backend. Si falta (ítem viejo o fecha sin
 * cotización), en pesos cae al importe original —que salvo excepción es ARS— y
 * en dólares devuelve 0, para no sumar pesos dentro de un total en dólares.
 *
 * @param {object} item   Renglón de la orden.
 * @param {string} base   Nombre del campo de importe ('costo_unitario', ...).
 * @param {string} moneda Moneda destino ('ARS' | 'USD').
 */
export const importeEnMoneda = (item, base, moneda) => {
  if (!item) return 0;
  const convertido = item[`${base}_${moneda === 'USD' ? 'usd' : 'ars'}`];
  if (convertido !== null && convertido !== undefined && convertido !== '') {
    return Number(convertido) || 0;
  }
  if (moneda === 'USD') return 0;
  if (item.moneda === 'USD') return 0;
  return Number(item[base]) || 0;
};

/** Suma cantidad × importe unitario sobre una lista de renglones. */
export const totalizar = (items, { base, cantidad, moneda }) =>
  (items || []).reduce(
    (acc, it) => acc + (Number(it[cantidad]) || 0) * importeEnMoneda(it, base, moneda),
    0,
  );

/**
 * True si la lista mezcla monedas distintas. Sirve para avisar al usuario por
 * qué el total no coincide con la suma visual de los importes de cada renglón.
 */
export const tieneMonedasMixtas = (...listas) => {
  const monedas = new Set();
  listas.forEach((lista) => (lista || []).forEach((it) => {
    if (it && (it.costo_unitario != null || it.precio_unitario != null || it.costo_hora != null)) {
      monedas.add(it.moneda || 'ARS');
    }
  }));
  return monedas.size > 1;
};

/** Formatea un importe con el símbolo de su moneda. */
export const fmtImporte = (valor, moneda, decimales) => {
  if (valor === null || valor === undefined) return '—';
  const dec = decimales != null ? decimales : (moneda === 'USD' ? 2 : 0);
  return `${simboloMoneda(moneda)} ${Number(valor).toLocaleString('es-AR', {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  })}`;
};
